import { Card } from '@grupoboticario/flora-react'

import Addresses from './Addresses'
import Divider from './Divider'
import Forecast from './Forecast'
import Receiver from './Receiver'
import TrackingID from './TrackingID'
import Updates from './Updates'

const Info = () => {
  return (
    <Card css={{ width: '100%', marginTop: '20px', padding: '32px', boxShadow: '0px 4px 20px 0px #0000001F' }}>
      <TrackingID />
      <Divider />
      <Forecast />
      <Divider />
      <Addresses />
      <Receiver />
      <Divider />
      <Updates />
    </Card>
  )
}

export default Info
